module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Norman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Norman is the creator of the Gorean Saga, the longest-running series of adventure novels in science fiction history. He is also the author of the science fiction series the Telnarian Histories, as well as "), _c('I', [_vm._v("Ghost Dance")]), _vm._v(", "), _c('I', [_vm._v("Time Slave")]), _vm._v(", "), _c('I', [_vm._v("The Totems of Abydos")]), _vm._v(", "), _c('I', [_vm._v("Imaginative Sex")]), _vm._v(", and "), _c('I', [_vm._v("Norman Invasions")]), _vm._v(". Norman is married and has three children.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TjP4lU/tc-custom/9781480499546.jpg?1733033197479",
      "alt": "This image is the cover for the book Chieftain, Telnarian Histories"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chieftain, Telnarian Histories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A peasant is sent to the arena, fodder for the carnage—but before the horrified gaze of noble ladies, the warrior named Dog slaughters headsmen, hunters, and beasts to win freedom as a full‑fledged gladiator. Then deep‑space rebels attack an Empire ship where Dog performs combat killings for the amusement of the passengers, and the gladiator becomes a rebel. Now a beautiful officer of the court finds her life depends on the mercy of Dog, the man she ordered put to death! ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0